module.exports = __webpack_public_path__ + "static/media/barbarians_cover.080aba90.jpg";